export const ACCESS_SERVICE_PLUGIN_TOKEN = 'ACCESS_SERVICE_PLUGIN_TOKEN';
export const SESSION_REQUIRE_NEW_PASSWORD = 'requireNewPassword';
export const START_SESSION_BY_LINK_SECRET = 'startSessionByLinkSecret';